import React from "react";
import { SvgIcon } from "@mui/material";

const ShareIcon = () => {
  const styles = {
    icon: {
      height: 18,
      width: 18
    }
  };

  return (
    <SvgIcon style={styles.icon}>
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.9621 11.0492C12.9836 11.0492 12.1163 11.5343 11.5878 12.2763L6.81216 9.88875C6.90216 9.60834 6.95081 9.30966 6.95081 9C6.95081 8.69034 6.90216 8.39138 6.81216 8.11097L11.5875 5.72344C12.116 6.46594 12.9833 6.95081 13.9618 6.95081C15.5683 6.95081 16.875 5.64412 16.875 4.03791C16.875 2.43169 15.5683 1.125 13.9621 1.125C12.3559 1.125 11.0492 2.43169 11.0492 4.03791C11.0492 4.26459 11.0753 4.48538 11.1246 4.69716L6.26653 7.12603C5.73187 6.49125 4.93116 6.08709 4.03791 6.08709C2.43169 6.08709 1.125 7.39378 1.125 9C1.125 10.6062 2.43169 11.9129 4.03791 11.9129C4.93116 11.9129 5.73187 11.5087 6.26653 10.8737L11.1243 13.3028C11.0751 13.5146 11.0489 13.7354 11.0489 13.9621C11.0492 15.5683 12.3559 16.875 13.9621 16.875C15.5683 16.875 16.875 15.5683 16.875 13.9621C16.875 12.3559 15.5683 11.0492 13.9621 11.0492ZM13.9621 2.25C14.9479 2.25 15.75 3.05213 15.75 4.03791C15.75 5.02369 14.9479 5.82581 13.9621 5.82581C12.9763 5.82581 12.1745 5.02369 12.1745 4.03791C12.1745 3.05213 12.9763 2.25 13.9621 2.25ZM4.03791 10.7879C3.05213 10.7879 2.25 9.98606 2.25 9C2.25 8.01422 3.05213 7.21209 4.03791 7.21209C5.02369 7.21209 5.82581 8.01422 5.82581 9C5.82581 9.98606 5.02369 10.7879 4.03791 10.7879ZM13.9621 15.75C12.9763 15.75 12.1745 14.9479 12.1745 13.9621C12.1745 12.9763 12.9766 12.1745 13.9621 12.1745C14.9482 12.1745 15.75 12.9766 15.75 13.9621C15.75 14.9479 14.9479 15.75 13.9621 15.75Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
};
export default ShareIcon;